<template>
  <header class="back_header">
    <div v-if="type != 0" @click="goUpper">
      <div class="return">
        <span class="iconfont iconfanhui"></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    type: Number,
    isCustomeBack: Boolean
  },
  methods: {
    goUpper() {
      if (this.isCustomeBack) {
        this.$emit("customeBackEvent");
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.back_header {
  background-color: #ffffff;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 45px;

  .return {
    width: 20%;
    height: 100%;
  }
  .iconfanhui {
    color: #333333;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
  }
}
</style>
